import { cn } from "@/lib/utils";

export const defaultColor = "#ebc302";

type StarIconProps = {
    fill?: string;
    className?: string;

};
export function StarIcon({ fill = defaultColor, className }: StarIconProps) {
    return <svg
        className={cn(
            className
        )}
        width="24"
        height="24"
        viewBox="0 0 2.9746201 2.9746201"
        version="1.1"
        id="svg1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <defs
            id="defs1" />
        <g
            id="layer1"
            transform="translate(-191.02916,-153.45833)">
            <path
                id="path9"
                d="m 194.00378,154.1212 -1.37477,0.43145 -0.93698,-1.09432 0.43144,1.37478 -1.09431,0.93697 1.37477,-0.43144 0.93698,1.09431 -0.43145,-1.37477 z"
                style={{
                    display: "inline",
                    fill: fill,
                    fillOpacity: 1,
                    fillRule: "nonzero",
                    stroke: "none",
                }}
            />
            <path
                id="path10"
                d="m 192.88615,153.69772 -0.42369,0.73378 -0.56691,-0.62971 0.21908,0.81844 -0.84597,-0.0441 0.73378,0.42368 -0.62971,0.56692 0.81845,-0.21943 -0.0445,0.84631 0.42368,-0.73378 0.56727,0.62971 -0.21943,-0.81844 0.84632,0.0441 -0.73378,-0.42369 0.62935,-0.56691 -0.81809,0.21907 z"
                style={{
                    display: "inline",
                    fill: fill,
                    fillOpacity: 1,
                    fillRule: "nonzero",
                    stroke: "none",
                }}
            />
        </g>
    </svg>;
}